import { PropsWithChildren, ReactNode } from 'react';
import styles from './stepped-form.module.scss';

const FormFooter = (props: PropsWithChildren<ReactNode>) => {
    return <footer className={styles.footer}>{props.children}</footer>;
};

export default FormFooter;
